<!-- TODO Fix everything -->
<mat-sidenav-container *ngIf="viewMode !== 'mobile'" class="sidenav-container create-notification-sidenav">
    <mat-sidenav mode="side" opened class="sidenav" autoFocus="false">
      <mat-nav-list class="outer-nav-list">
        <div>
          <mat-list-item [class.is-active]="isActive('/create-notification/notification-title')" (click)="updatePrevNextBtnState(true,false,'notificationTitle', '/create-notification/notification-title')" >
            <div style="margin-left: 15px;">
              Notification Title
            </div>
          </mat-list-item>
          <mat-list-item [class.is-active]="isActive('/create-notification/notification-doc')" (click)="updatePrevNextBtnState(false,false, 'notificationDoc', '/create-notification/notification-doc')" >
            <div style="margin-left: 15px;" [ngClass]=" isNotiDoc ? 'required-field': '' ">
              Notification document
            </div>
          </mat-list-item>
          <mat-list-item [class.is-active]="isActive('/create-notification/recipients')" (click)="updatePrevNextBtnState(false,false, 'recipients', '/create-notification/recipients'); asterixValidation()">
            <div style="margin-left: 15px;" [ngClass]=" isRecepient ? 'required-field': '' ">
              Recipients
            </div>
          </mat-list-item>
          <mat-list-item [class.is-active]="isActive('/create-notification/message-attachment')" (click)="updatePrevNextBtnState(false,false, 'messageAttachment', '/create-notification/message-attachment')">
            <div style="margin-left: 15px;" [ngClass]=" isMess_Att ? 'required-field': '' ">
              Message and attachments
            </div>
          </mat-list-item>
          <mat-list-item [class.is-active]="isActive('/create-notification/configure-feedback')" (click)="updatePrevNextBtnState(false,false, 'configureFeedback', '/create-notification/configure-feedback')">
            <div style="margin-left: 15px;">
              Configure feedback form
            </div>
          </mat-list-item>
          <mat-list-item [class.is-active]="isActive('/create-notification/due-date-reminder')" (click)="updatePrevNextBtnState(false,false, 'dueDateReminder', '/create-notification/due-date-reminder')">
            <div style="margin-left: 15px;" [ngClass]=" isDue_Rem ? 'required-field': '' ">
              Due date and reminder
            </div>
          </mat-list-item>
           <mat-list-item [class.is-active]="isActive('/create-notification/daily-summary-report')" (click)="updatePrevNextBtnState(false,true, 'dailySummaryReport', '/create-notification/daily-summary-report')">
            <div style="margin-left: 15px;" [ngClass]=" isDailyReport ? 'required-field': '' ">
              Daily Summary Report
            </div>
          </mat-list-item>
        </div>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="desktop-sidenav-content">
      <ng-content select="[sidecontent]"></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
  